import React, { useEffect, useState } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { Autocomplete } from "@material-ui/lab";
import { DialogActions, TextField, Typography } from "@material-ui/core";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import Swal from "sweetalert2";

function MapPlaces({
  address = "",
  city = "",
  province = "",
  countryCode = "",
  postalCode = "",
  onPinLocation,
  onCloseDialog,
}) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBFIpKmaagFwzA8NZs1a3eIJLEsfk_swyk",
    libraries: ["places"],
  });
  if (!isLoaded) return <div>Loading Maps...</div>;
  return (
    <Map
      address={address}
      city={city}
      province={province}
      countryCode={countryCode}
      postalCode={postalCode}
      onPinLocation={onPinLocation}
      onCloseDialog={onCloseDialog}
    />
  );
}

function Map({
  address = "",
  city = "",
  province = "",
  countryCode = "",
  postalCode = "",
  onPinLocation,
  onCloseDialog,
}) {
  const { reload } = useGlobalData();
  const [selected, setSelected] = useState({
    lat: -6.175364542920759,
    lng: 106.82715486139902,
  });
  const [selectedFormattedAddress, setSelectedFormattedAddress] = useState("");
  const [
    selectedLongAddressComponents,
    setSelectedLongAddressComponents,
  ] = useState([]);
  const [
    selectedShortAddressComponents,
    setSelectedShortAddressComponents,
  ] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedPostalCode, setSelectedPostalCode] = useState("");
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  useEffect(() => {
    var fullAddress = "";

    if (address != "") {
      fullAddress = address;
    }
    if (city != "") {
      fullAddress = fullAddress + " " + city;
    }
    if (province != "") {
      fullAddress = fullAddress + " " + province;
    }
    if (countryCode != "") {
      fullAddress = fullAddress + " " + countryCode;
    }
    if (postalCode != "") {
      fullAddress = fullAddress + " " + postalCode;
    }
    console.log("addr", address);
    if (address != "") {
      getGeoCode(fullAddress);
    }
  }, [reload]);

  return (
    <React.Fragment>
      <div>
        <Autocomplete
          freeSolo
          id="mapPlaces"
          disableClearable
          options={data}
          value={selected}
          inputValue={value}
          size="small"
          getOptionLabel={(option) => {
            if (option && option.place_id) {
              return option.description;
            } else {
              return "";
            }
          }}
          onChange={async (event, value) => {
            setValue(value.description, false);
            if (value.description != "") {
              getGeoCode(value.description);
            }
            clearSuggestions();
          }}
          onInputChange={(event, inputValue) => {
            setValue(inputValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search Address"
              margin="normal"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </div>
      <GoogleMap
        zoom={15}
        center={selected}
        mapContainerClassName="map-container"
      >
        {selected && <Marker position={selected} />}
      </GoogleMap>
      {selectedFormattedAddress ? (
        <Typography align="center" className="my-3">
          {selectedFormattedAddress}
        </Typography>
      ) : null}

      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={onCloseDialog}
        >
          <i className="fas fa-window-close"></i>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success btn-md btn-pill btn-bold"
          onClick={() => {
            if (selectedFormattedAddress) {
              onPinLocation(
                selectedFormattedAddress,
                selectedShortAddressComponents,
                selectedLongAddressComponents,
                selectedAddress,
                selectedCity,
                selectedProvince,
                selectedCountryCode,
                selectedPostalCode
              );
            } else {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text:
                  "Please search and select Address first before adopting the address",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          }}
        >
          <i className="fas fa-map-marker-alt"></i>
          Pin Location
        </button>
      </DialogActions>
    </React.Fragment>
  );
  async function getGeoCode(address = "") {
    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);
    const longAddressComponents = results[0].address_components.reduce(
      (seed, { long_name, types }) => (
        types.forEach((t) => (seed[t] = long_name)), seed
      ),
      {}
    );
    const shortAddressComponents = results[0].address_components.reduce(
      (seed, { short_name, types }) => (
        types.forEach((t) => (seed[t] = short_name)), seed
      ),
      {}
    );
    console.log("dsf", results[0]);
    console.log("longAddressComponents", longAddressComponents);
    setSelectedFormattedAddress(results[0].formatted_address);
    setSelectedLongAddressComponents(longAddressComponents);
    setSelectedShortAddressComponents(shortAddressComponents);
    setSelectedAddress(
      `${
        longAddressComponents.subpremise
          ? longAddressComponents.subpremise + `, `
          : ``
      }${
        longAddressComponents.premise
          ? longAddressComponents.premise + `, `
          : ``
      }${
        longAddressComponents.street_address
          ? longAddressComponents.street_address + `, `
          : ``
      }${
        longAddressComponents.route && longAddressComponents.street_number
          ? longAddressComponents.route + ` `
          : longAddressComponents.route && !longAddressComponents.street_number
          ? longAddressComponents.route + `, `
          : ``
      }${
        longAddressComponents.street_number
          ? longAddressComponents.street_number + `, `
          : ``
      }${
        longAddressComponents.sublocality
          ? longAddressComponents.sublocality + `, `
          : ``
      }${
        longAddressComponents.administrative_area_level_7
          ? longAddressComponents.administrative_area_level_7 + `, `
          : ``
      }${
        longAddressComponents.administrative_area_level_6
          ? longAddressComponents.administrative_area_level_6 + `, `
          : ``
      }${
        longAddressComponents.administrative_area_level_5
          ? longAddressComponents.administrative_area_level_5 + `, `
          : ``
      }${
        longAddressComponents.administrative_area_level_4
          ? longAddressComponents.administrative_area_level_4 + `, `
          : ``
      }${
        longAddressComponents.administrative_area_level_3
          ? longAddressComponents.administrative_area_level_3 + `, `
          : ``
      }`.slice(0, -2)
    );
    setSelectedCity(
      `${
        longAddressComponents.locality
          ? longAddressComponents.locality
          : longAddressComponents.administrative_area_level_2
          ? longAddressComponents.administrative_area_level_2
          : ``
      }`
    );
    setSelectedProvince(
      `${
        longAddressComponents.administrative_area_level_1
          ? longAddressComponents.administrative_area_level_1
          : ``
      }`
    );
    setSelectedCountryCode(
      `${shortAddressComponents.country ? shortAddressComponents.country : ``}`
    );
    setSelectedPostalCode(
      `${
        longAddressComponents.postal_code
          ? longAddressComponents.postal_code
          : ``
      }`
    );
    setSelected({ lat, lng });
  }
}

export default MapPlaces;
